import React, { useContext, useEffect,Dispatch,SetStateAction, useRef, useMemo } from "react";
import "./MainCorp.css"

import { ContainerRestau } from "../../../../components/containerRestau/containerRestau";
import { AppContext } from "../../../../context/AppContext";

import DefilmentBar from "../../../../components/defilmentBar/defilmentBar";
import {  Restaurant, cityWithOtherPreposition } from "../../../../components/types/types";
import { Link } from "react-router-dom";
import { RestaurantContext } from "../../../../context/RestaurantContext";


interface MainCorpProps {
    listBase:Restaurant[],
    setLengthResto: Dispatch<SetStateAction<number>>,
    cityLoad?:string,
    cityLoadBrut?:string
}

const MainCorp:React.FC<MainCorpProps> = ({cityLoad='',cityLoadBrut='',listBase,setLengthResto}) => {
    const {currentHomePage, setCurrentHomePage,homeImagesUnlocked,setHomeImagesUnlocked,filterChoose,restoFav,searchValueHome,date_selected,hour_selected,isLogin, idRestaurant} = useContext(AppContext)
    const { listRestoFiltered , listRestoBackup } = useContext(RestaurantContext)
    const title = `QuelResto vous permet (enfin) de trouver facilement un bon restaurant en ligne.`

    const isDesktop = window.matchMedia("(min-width:701px)").matches;
    const LIMIT = isDesktop ? 12 : 3;
    const INITIAL_LIMIT = isDesktop ? 15 : 4;
    const containerRestoRef = useRef<HTMLDivElement>(null)
    const currentYear = new Date().getFullYear();

    


    useEffect(() => {
        if(listRestoFiltered && listRestoFiltered.length > 0){setCurrentHomePage(1); setLengthResto(listRestoFiltered.length);window.scrollTo({ top: 0, behavior: 'smooth' })}
        else if(listRestoBackup && listRestoBackup.length > 0) setLengthResto(listRestoBackup.length)
    },[listRestoFiltered])

    const normalizeCity = (s?: string) =>
        (s || "").trim().toLowerCase();

    const sortedList = useMemo(() => {
        const base = listRestoFiltered ?? [];
        if (!base.length) return [];

        const q = searchValueHome.trim().toLowerCase();
        const filtered = q ? base.filter(r => r.name.toLowerCase().includes(q)) : base;
        const targetCity = normalizeCity(cityLoadBrut);
        const doSplit = targetCity && targetCity !== normalizeCity("à proximité");

        const boostFirst = (arr: Restaurant[]) => {
            if (!idRestaurant || idRestaurant === -1) return arr;
            const copy = arr.slice();
            copy.sort((a, b) => {
            if (a.idrestaurant === idRestaurant) return -1;
            if (b.idrestaurant === idRestaurant) return 1;
            return 0;
            });
            return copy;
        };

        if (!doSplit) {
            return boostFirst(filtered);
        }

        const inCity: Restaurant[] = [];
        const around: Restaurant[] = [];

        for (const r of filtered) {
            const rCity = normalizeCity(r.address?.[1]);
            if (rCity === targetCity) inCity.push(r);
            else around.push(r);
        }
        return [...boostFirst(inCity), ...boostFirst(around)];
    }, [listRestoFiltered, searchValueHome, idRestaurant, cityLoadBrut]);

    const { indexFirstAround, hasCityResto } = useMemo(() => {
        if (!cityLoadBrut || cityLoadBrut === 'à proximité') return { indexFirstAround: -1, hasCityResto: true };
        if (!sortedList.length) return { indexFirstAround: -1, hasCityResto: false };
        const hasCityResto = sortedList.some(
            (r) => r.address && r.address[1] === cityLoadBrut
        );
        if (!hasCityResto) {
            return { indexFirstAround: 0, hasCityResto: false };
        }
        const idx = sortedList.findIndex(
            (r) => !r.address || r.address[1] !== cityLoadBrut
        );
        return { indexFirstAround: idx, hasCityResto: true };
    }, [sortedList, cityLoadBrut]);

    const pageItems = useMemo(() => {
        const start = (currentHomePage - 1) * 30;
        return sortedList.slice(start, start + 30);
    }, [sortedList, currentHomePage]);

    useEffect(() => {
        window.scrollTo({top: 0,behavior: 'auto'})
    },[searchValueHome,hour_selected,date_selected,filterChoose])


    
    useEffect(() => {
        if (window.innerWidth > 700 || !pageItems?.length) return;
        
        let cleanup: (() => void) | null = null;
        const timer = setTimeout(() => {
            let scheduled = false;
            let containers: HTMLElement[] = [];

            const checkCentered = () => {
                scheduled = false;
                const viewportCenter = window.innerHeight / 2;
                let minDistance = Infinity;
                let centered: HTMLElement | null = null;
                for (const el of containers) {
                    const rect = el.getBoundingClientRect();
                    if (rect.bottom < 0 || rect.top > window.innerHeight) continue;
                    
                    const elemCenter = rect.top + rect.height / 2;
                    const dist = Math.abs(elemCenter - viewportCenter);
                    
                    if (dist < minDistance) {
                        minDistance = dist;
                        centered = el;
                    }
                }
                for (const el of containers) {
                    const shouldBeCentered = el === centered;
                    const isCentered = el.classList.contains('centered');
                    
                    if (shouldBeCentered && !isCentered) {
                        el.classList.add('centered');
                    } else if (!shouldBeCentered && isCentered) {
                        el.classList.remove('centered');
                    }
                }
            };
            const onScroll = () => {
                if (scheduled) return;
                scheduled = true;
                requestAnimationFrame(checkCentered);
            };
            containers = Array.from(document.querySelectorAll<HTMLElement>('.containerRestauUp'));
            if (!containers.length) return;

            window.addEventListener('scroll', onScroll, { passive: true });
            requestAnimationFrame(checkCentered);

            cleanup = () => {
                window.removeEventListener('scroll', onScroll);
            };
        }, 3000);

        return () => {
            clearTimeout(timer);
            if (cleanup) cleanup();
        };
    }, [pageItems]);

    useEffect(() => {
        if (homeImagesUnlocked) return;
        const needsUnlock = pageItems.length > INITIAL_LIMIT;
        if (!needsUnlock) {
            setHomeImagesUnlocked(true);
            return;
        }

        const el = containerRestoRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            (entries) => {
            if (entries[0]?.isIntersecting) {
                setHomeImagesUnlocked(true);
                observer.disconnect();
            }
            },
            { threshold: 0.1 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [pageItems, homeImagesUnlocked, INITIAL_LIMIT, setHomeImagesUnlocked]);

    return (
            <div className="mainCorpRestau" id='mainCorpRestau' >
                {cityLoad && cityLoad !== 'restaurants-a-proximite' && <div className="titleCityLoad"><h1 className=" largerTitle" >Les meilleurs restaurants {cityLoad}{cityLoad !== 'à proximité' ? `, Maine-et-Loire – ${currentYear}` : ''}</h1></div>}
                {listRestoFiltered.length > 0 && <span className="numberList XsmallText ">{`${sortedList.length} résultat${sortedList.length>1? 's' : ''}`}</span> }
                {isLogin === 0 && <Link to="/contact_inscription" className="registerResto pointer lowOpacityHover XsmallText">Inscrire son restaurant</Link> }
                {!hasCityResto && listRestoFiltered.length > 0 && cityLoad && <p className="title midText explainCity" >Aucun restaurant correspondant dans la ville recherchée</p>}
                { 
                    listRestoFiltered.length > 0 ? 
                    pageItems.map((elem,index) => {
                        const globalIndex = (currentHomePage - 1) * 30 + index;
                        const showAroundTitle =
                            !!cityLoad &&
                            cityLoad !== 'restaurants-a-proximite' &&
                            indexFirstAround !== -1 &&
                            globalIndex === indexFirstAround;
                        return <React.Fragment key={'elemListContainer' + elem.idrestaurant}>
                            {showAroundTitle && (
                                <div className="aroundTitle">
                                    <div className={`${(!hasCityResto && listRestoFiltered.length > 0 && cityLoad) ? 'isAtTop' : ''}`}></div>
                                    <h2 className="largerTitle">
                                        Recherche étendue : les meilleurs restaurants aux alentours {cityWithOtherPreposition(cityLoad)}
                                    </h2>
                                </div>
                            )}
                            <ContainerRestau  imgLocked={!homeImagesUnlocked ? index > INITIAL_LIMIT : false} id={index}  visibleCity={elem.visiblecity || ''} city={elem.address[1]} total_price={elem.total_price} cuisines={elem.cuisines} idResto={elem.idrestaurant}   img={elem.devanture} name={elem.name} note={elem.note} imgSup={elem.listimg} isFav={restoFav.includes(elem.idrestaurant)} type={elem.type} nbr_review={elem.nbr_review} date_published={elem.date_published} id_url={elem.id_url}/>   
                            {currentHomePage===1 && index === LIMIT &&  (
                            <div ref={containerRestoRef} style={{ height: 1 }} />
                            )}
                        </React.Fragment>
                        })
                        :
                        <div className="noFilterMatch">
                            {
                                listRestoBackup && listRestoBackup.length > 0 ?
                                <>
                                    <p className="titleList midText">Liste de restaurant se rapprochant le plus de votre recherche :</p>
                                    <div className="liste">
                                        {
                                        listRestoBackup.length > 0  && listRestoBackup.slice((currentHomePage-1)*30,currentHomePage*30).map((elem,index) => (
                                            <ContainerRestau id={index} key={'secondContainer'+elem.idrestaurant} visibleCity={elem.visiblecity || ''} city={elem.address[1]} total_price={elem.total_price} cuisines={elem.cuisines} idResto={elem.idrestaurant} img={elem.devanture} name={elem.name} note={elem.note} imgSup={elem.listimg} isFav={restoFav.includes(elem.idrestaurant)} type={elem.type}  nbr_review={elem.nbr_review} date_published={elem.date_published} id_url={elem.id_url}/>   
                                        ))
                                        }
                                    </div>
                                </>
                                :
                                <p className="title midText explainNoResto" >{cityLoad && filterChoose.length === 0 ? 'Aucun restaurant correspondant dans la ville recherchée' : `Aucun restaurant correspondant à votre recherche. Essayez d’enlever un ou plusieurs filtres pour voir plus de résultats.`}</p>
                            }
                        </div> 
                }
                {listRestoFiltered.length > 0 && (
                    <div className="mainCorpTextAccueil">
                        <div className="textAccueil smallText">
                            {cityLoad ? <h2>{title}</h2> : <h1>{title}</h1>}<br/>
                            Ouvert depuis le 29 avril, notre objectif est de référencer tous les bons restaurants autour de vous.
                        </div>
                        <p className="textAccueil XsmallText" style={{marginTop:'3em'}}>
                           Pour en savoir plus : <a href="/APropos" className="link">À propos de QuelResto</a> et <a href="/Fonctionnement" className="link">Fonctionnement du site</a>.
                        </p>
                    </div>
                )}

                {listRestoBackup && listRestoBackup.length > 0 && <DefilmentBar currentPage={currentHomePage} totalResult={sortedList.length > 0 ?  sortedList.length : (listRestoBackup && listRestoBackup.length > 0 ? listRestoBackup.length : 0) } nbrForPage={30} setCurrentPage={setCurrentHomePage} nbrPages={Math.ceil(sortedList.length / 30)} dom="bodyCorp"/> }
            </div>
    )
}
export default MainCorp



